import { extendTheme } from "@chakra-ui/react";
const theme = extendTheme({
  fonts: {
    body: "Cera Pro",
    heading: "Cera Pro",
  },
});
export default theme;
